export enum ActionItemType {
  TASK = "TASK",
  COMMITMENT = "COMMITMENT",
}

export enum ActionItemTypeLabel {
  TASK = "Task",
  COMMITMENT = "Commitment",
}

export enum ActionItemSubType {
  SOFT = "SOFT",
  HARD = "HARD",
}

export enum ActionItemStatus {
  OPEN = "OPEN",
  COMPLETED = "COMPLETED",
}

export enum ActionItemPriority {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export enum ActionItemPriorityLabel {
  CRITICAL = "Critical",
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low",
}

export enum ActionItemSubTypeLabel {
  SOFT = "Soft",
  HARD = "Hard",
}

export enum ActionItemStatusLabel {
  OPEN = "Open",
  COMPLETED = "Completed",
}

export enum ActionItemOwnerType {
  USER = "USER",
  CONTACT = "CONTACT",
}
